module.exports = __webpack_public_path__ + "static/media/d1.e8e5e035.jpg";